var $26bd589e8a2a66db$exports = {};
$26bd589e8a2a66db$exports = {
    "valid": `G\xfcltig`
};


export {$26bd589e8a2a66db$exports as default};
//# sourceMappingURL=de-DE.mjs.map
